import type { Event } from '../types'

/**
 * The token a client compares to decide whether an event's cached lineup, sets
 * and stages are stale: `t` + `contentUpdatedAt` millis. Undefined until the
 * event's first stamp lands.
 */
export function eventContentVersion(event: Pick<Event, 'contentUpdatedAt'>): string | undefined {
  const millis = event.contentUpdatedAt?.toMillis()
  return millis ? `t${millis}` : undefined
}
